import React from 'react';
import AssetsManager from '../../classes/AssetsManager';
import MathUtils from '../../classes/utilities/MathUtils';
import { useTypedSelector } from '../../state/hooks';

export default function FileUploadPercent(props)
{
	const files = useTypedSelector(state => state.fileModule.progressList);

	const renderPercent = (() => 
	{
		if (!files || Object.keys(files).length <= 0) return "Please Wait...";

		const id = Object.keys(files)[0];
		const details = AssetsManager.getFileLoadProgress(id);
		return details ? Math.ceil((MathUtils.clamp01(details.progress) * 100)) + "%" : "0%";

	})();

	return (
		<div>
			{renderPercent}
		</div>
	);
}
